import { Component, EventEmitter, Input, Output, QueryList, SimpleChange, ViewChild, ViewChildren } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatSort } from '@angular/material/sort';
import { DailogModalComponent } from '../../../../shared/elements/dailog-modal/dailog-modal.component';
import { MaintenanceService } from '../../../../techopsv4/services/maintenanceService';
import { ToastrService } from 'ngx-toastr';
import { SharedAuthService } from '../../../../shared/shared.auth.service';
@Component({
    selector: 'app-fund-maintenance-table',
    templateUrl: './fund-maintenance-table.component.html',
    styleUrl: './fund-maintenance-table.component.scss',
    standalone: false
})
export class FundMaintenanceV4Component {
  displayedColumns: string[] = ['Funding_Source', 'Funding_SegmentID', 'Funding_Segment', 'Funding_Owner', 'Funding_Delegate', 'Action'];
  @Input() dataSource: MatTableDataSource<any> = new MatTableDataSource([]);
  @Input() oldDataSource: any[];
  @Input() searchString: string;

  @Output() sortChangeEvent: EventEmitter<any> = new EventEmitter();
  @Output() SegmentDeleted: EventEmitter<any> = new EventEmitter();
  @Output() SegmentEditedByIdSubmit: EventEmitter<any> = new EventEmitter();

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChildren(MatMenuTrigger) trigger: QueryList<MatMenuTrigger>;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild('modalEditSegment', { static: false }) modalEditSegment;

  loggedusermail: any;
  applist: any = [];
  isAdminRole: any;

  segmentSourceFilterApplied: boolean = false;
  segmentIdFilterApplied : boolean = false;
  segmentNameFilterApplied : boolean = false;
  searchValue: string;
  filterList: any;
  filValue = [];
  filterLists: any = [];
  Allfilter = [];
  Finalfilter = [];
  segmentIdFilter = [];
  segmentNameFilter = [];
  selectedColumn: string;
  searchTxt: string;
  previousSelection = [];
  restrictionEdit:boolean = false;
  isEditSegment:boolean = false;
  editSegmentDataSource: any;
  public dialogRef: MatDialogRef<FundMaintenanceV4Component>;

  constructor(
    public dialog: MatDialog, 
    public toaster: ToastrService, 
    private maintenanceService: MaintenanceService,
   public sharedAuthService: SharedAuthService,) {

  }
  ngOnInit() {
    this.fundOwnerRestrictionEdit();
  }
  ngOnChanges(changes: { [searchString: string]: SimpleChange }) {
    this.fundOwnerRestrictionEdit();
    if (this.dataSource && this.dataSource.data) {
      this.dataSource.data = this.dataSource.data.sort((a, b) => a['Funding_Segment'].toLocaleLowerCase() < b['Funding_Segment'].toLocaleLowerCase() ? -1 : 1)
    }
    if (this.dataSource) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
    if (changes['searchString']) {
      const change: string = changes['searchString'].currentValue;
      this.searchDataSet(change);
    }
  }
  
  ngAfterViewInit() {
    if (this.dataSource) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }
  searchDataSet(search) {
    if(this.dataSource) {
       this.dataSource.filterPredicate = function (record, filter) {
        let ownerFound = false;
        let delegateFound = false;
        record['Funding_Owner'].forEach((item) => {
          if (item['displayName'].toLocaleLowerCase().indexOf(filter.toLocaleLowerCase()) !== -1) {
            ownerFound = true;
          }
        });
        record['Funding_Delegate'].forEach((item) => {
          if (item['displayName'].toLocaleLowerCase().indexOf(filter.toLocaleLowerCase()) !== -1) {
            delegateFound = true;
          }
        });
        return (
          record.Funding_Source.toLocaleLowerCase().indexOf(filter.toLocaleLowerCase()) !== -1 ||
          record.Funding_Segment.toLocaleLowerCase().indexOf(filter.toLocaleLowerCase()) !== -1 || 
          record.Funding_SegmentID.toLocaleLowerCase().indexOf(filter.toLocaleLowerCase()) !== -1 ||
          ownerFound || delegateFound
        );
      }
    }
    if ((search || search == '') && this.dataSource) {
      this.dataSource['filter'] = search.trim().toLowerCase();
    }
  }
  filterDropdown(column) {

    this.selectedColumn = column;
    this.searchValue = '';
    let index;

    if (column == "Funding_Source")
      index = 0;
    else if (column == 'Funding_SegmentID')
      index = 1;
    else if (column == 'Funding_Segment')
      index = 2;

    this.trigger.toArray().forEach((item: MatMenuTrigger, i: number) => {
      if (i !== index && item.menuOpen) {
        item.closeMenu()
      }
    });

    if (column == 'Funding_Source') {
      if (this.segmentSourceFilterApplied) {
        this.filterList = this.dataSource.data.map((item) => { return item.Funding_Source });
      }
      else {
        this.filterList = this.oldDataSource.map((item) => { return item.Funding_Source });
      }
      this.filValue = this.segmentIdFilter;
      this.trigger.toArray()[0].openMenu();
    }
    if (column == 'Funding_SegmentID') {
      if (this.segmentNameFilterApplied) {
        this.filterList = this.dataSource.data.map((item) => { return item.Funding_SegmentID });
      }
      else {
        this.filterList = this.oldDataSource.map((item) => { return item.Funding_SegmentID });
      }
      this.filValue = this.segmentIdFilter;
      this.trigger.toArray()[1].openMenu();
    }
    if (column == 'Funding_Segment') {
      if (this.segmentIdFilterApplied) {
        this.filterList = this.dataSource.data.map((item) => { return item.Funding_Segment });
      }
      else {
        this.filterList = this.oldDataSource.map((item) => { return item.Funding_Segment });
      }
      this.filValue = this.segmentNameFilter;
      this.trigger.toArray()[2].openMenu();
    }
    this.filterList = new Set([...this.filterList]);
    this.filterLists = Array.from(this.filterList);
  }

  selectionChange(event) {
    let newevent;
    if (this.selectedColumn == 'Funding_Source') {
      this.Allfilter.forEach((a, i) => { if (a.column == 'Funding_Source') this.Allfilter.splice(i, 1) });
      newevent = this.checkPrevious(event,this.segmentIdFilter);
      if (newevent.source._value.length > 0) {
        this.segmentIdFilter = newevent.source._value;
        this.Allfilter.push({ column: 'Funding_Source', value: newevent.source._value });
      } else {
        this.segmentIdFilter = [];
      }
      this.trigger.toArray()[0].openMenu();
    }
    if (this.selectedColumn == 'Funding_SegmentID') {
      this.Allfilter.forEach((a, i) => { if (a.column == 'Funding_SegmentID') this.Allfilter.splice(i, 1) });
      newevent = this.checkPrevious(event,this.segmentIdFilter);
      if (newevent.source._value.length > 0) {
        this.segmentIdFilter = newevent.source._value;
        this.Allfilter.push({ column: 'Funding_SegmentID', value: newevent.source._value });
      } else {
        this.segmentIdFilter = [];
      }
      this.trigger.toArray()[1].openMenu();
    }

    if (this.selectedColumn == 'Funding_Segment') {
      this.Allfilter.forEach((a, i) => { if (a.column == 'Funding_Segment') this.Allfilter.splice(i, 1) });
      newevent = this.checkPrevious(event,this.segmentNameFilter);
      if (newevent.source._value.length > 0) {
        this.segmentNameFilter = newevent.source._value;
        this.Allfilter.push({ column: 'Funding_Segment', value: newevent.source._value });
      } else {
        this.segmentNameFilter = [];
      }
      this.trigger.toArray()[2].openMenu();
    }
  }

  checkPrevious(event,prevArr:any = []) {
    this.previousSelection = prevArr;
    const filterList:Array<any> = [...this.filterLists];
    if (this.previousSelection && this.previousSelection.length > 0) {
      let isPrevValueUnselected = true;
      for (let i = 0; i < this.previousSelection.length; i++) {
        //If previous selection is in DropDownData and not in event then only add previous selection in Event Values(Server Side Search)
        const uncheckedElementName = event.options[0]._value;
        const unchekcedStatus = event.options[0]._selected;
        if (!(unchekcedStatus) && isPrevValueUnselected) { //check for unchecked elements
          if (this.previousSelection[i] == uncheckedElementName) //check for element which is unchecked
          {
            this.previousSelection.splice(i, 1);
            i--;
            isPrevValueUnselected = false;
          }
        } else if (filterList.includes(this.previousSelection[i]) && event.source._value.length > 0
          && !event.source._value.includes(this.previousSelection[i]))  //Checked cond1
        {
          event.source._value.push(this.previousSelection[i]);
        }
      }
    }
    if (event.source._value.length == 0) {//Unchecked cond2: element is unchecked after search
      for (let i = 0; i < this.previousSelection.length; i++) {
        if (filterList.includes(this.previousSelection[i])) {
          event.source._value.push(this.previousSelection[i]);
        }
      }
    }
    this.previousSelection = [... new Set(event.source._value)];
    return event
  }

  applyLocalFilter() {
    this.searchTxt = '';
    let filterdata = this.oldDataSource;
    this.Finalfilter.forEach((a, i) => { if (a.column == this.selectedColumn) this.Finalfilter.splice(i, 1) });
    this.Allfilter.forEach((element) => {
      if (element.column == this.selectedColumn) {
        this.Finalfilter.push(element);
      }
    });
    
    this.Finalfilter.forEach((e1) => {
      if (e1.column == 'Funding_Source') {
        if (e1.value.length > 0) {
          filterdata = filterdata.filter((item) => e1.value.some(e => e == item.Funding_Source));
          this.filterLists = filterdata.map((item) => { return item.Funding_Source });
          this.segmentSourceFilterApplied = true;
          this.dataSource = new MatTableDataSource(filterdata);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.trigger.toArray()[0].closeMenu();
        }
      }

      if (e1.column == 'Funding_SegmentID') {
        if (e1.value.length > 0) {
          filterdata = filterdata.filter((item) => e1.value.some(e => e == item.Funding_SegmentID));
          this.filterLists = filterdata.map((item) => { return item.Funding_SegmentID });
          this.segmentIdFilterApplied = true;
          this.dataSource = new MatTableDataSource(filterdata);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.trigger.toArray()[1].closeMenu();
        }
      }

      if (e1.column == 'Funding_Segment') {
        if (e1.value.length > 0) {
          filterdata = filterdata.filter((item) => e1.value.some(e => e == item.Funding_Segment));
          this.filterLists = filterdata.map((item) => { return item.Funding_Segment });
          this.segmentNameFilterApplied = true;
          this.dataSource = new MatTableDataSource(filterdata);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.trigger.toArray()[2].closeMenu();
        }
      }
    });
    if (this.Finalfilter.length == 0) {
      this.dataSource.data = this.oldDataSource;
      this.dataSource.paginator = this.paginator;
    }
    if (this.trigger.toArray()[0]) {
      this.trigger.toArray()[0].closeMenu();
    }
    if (this.trigger.toArray()[1]) {
      this.trigger.toArray()[1].closeMenu();
    }
    if (this.trigger.toArray()[2]) {
      this.trigger.toArray()[2].closeMenu();
    }
  }

  clearLocalFilter() {
    this.searchTxt = '';
    this.previousSelection = [];
    if (this.trigger.toArray()[0]) {
      this.trigger.toArray()[0].closeMenu();
    }
    if (this.trigger.toArray()[1]) {
      this.trigger.toArray()[1].closeMenu();
    }
    if (this.trigger.toArray()[2]) {
      this.trigger.toArray()[2].closeMenu();
    }

    if (this.selectedColumn == 'Funding_Source') {
      this.segmentIdFilter = [];
      this.segmentSourceFilterApplied = false;
      this.Finalfilter.forEach((a, i) => { if (a.column == 'Funding_Source') this.Finalfilter.splice(i, 1) });
      this.Allfilter.forEach((a, i) => { if (a.column == 'Funding_Source') this.Allfilter.splice(i, 1) });
    }

    if (this.selectedColumn == 'Funding_SegmentID') {
      this.segmentIdFilter = [];
      this.segmentIdFilterApplied = false;
      this.Finalfilter.forEach((a, i) => { if (a.column == 'Funding_SegmentID') this.Finalfilter.splice(i, 1) });
      this.Allfilter.forEach((a, i) => { if (a.column == 'Funding_SegmentID') this.Allfilter.splice(i, 1) });
    }
    if (this.selectedColumn == 'Funding_Segment') {
      this.segmentNameFilter = [];
      this.segmentNameFilterApplied = false;
      this.Finalfilter.forEach((a, i) => { if (a.column == 'Funding_Segment') this.Finalfilter.splice(i, 1) });
      this.Allfilter.forEach((a, i) => { if (a.column == 'Funding_Segment') this.Allfilter.splice(i, 1) });
    }
    this.applyLocalFilter();
  }

  clearallFilter() {
    if (this.trigger.toArray()[0]) {
      this.trigger.toArray()[0].closeMenu();
    }
    if (this.trigger.toArray()[1]) {
      this.trigger.toArray()[1].closeMenu();
    }
    if (this.trigger.toArray()[2]) {
      this.trigger.toArray()[2].closeMenu();
    }
    this.segmentIdFilterApplied = false;
    this.segmentNameFilterApplied = false;
    this.segmentSourceFilterApplied = false;
    this.Allfilter = [];
    this.Finalfilter = [];
    this.segmentIdFilter = [];
    this.segmentNameFilter = [];
    this.dataSource.data = this.oldDataSource;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  sortData(event) {
    let sort: any[] = [];
    if (event.direction) {
      sort = [[event.active, event.direction]];
    }
    this.sortChangeEvent.emit(sort);
  }

  fundOwnerRestrictionEdit() {
    this.restrictionEdit = this.sharedAuthService.getFundingAccessDetails('');
    if(this.restrictionEdit) {
      this.displayedColumns = ['Funding_Source', 'Funding_SegmentID', 'Funding_Segment', 'Funding_Owner', 'Funding_Delegate', 'Action', 'Reset_Filter'];
    } else {
      this.displayedColumns = ['Funding_Source', 'Funding_SegmentID', 'Funding_Segment', 'Funding_Owner', 'Funding_Delegate', 'Reset_Filter'];
    }
  }

  EditSegment(event:any) {
    this.editSegmentDataSource = JSON.parse(JSON.stringify(event));
    this.isEditSegment = true;
    this.modalEditSegment.show();
  }

  hidepopup(type) {
    if(type === 'editSegment') {
      this.isEditSegment = false;
      this.modalEditSegment.hide();
    }
  }

  DeleteSegmentKey(segmentKey: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '400px';
    dialogConfig.hasBackdrop = true;
    dialogConfig.minHeight = '200px';
    dialogConfig.panelClass = 'editStackHolder'
    dialogConfig.height = 'auto';
    // dialogConfig.autoFocus;
    dialogConfig.data = {
      title: 'Are you sure to delete the selected segment',
      buttonName: 'Delete',
      subTitle: ''
    };
    const dialogRef = this.dialog.open(DailogModalComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result['data'] === 'save') {
        this.maintenanceService.DeleteSegment(segmentKey).subscribe((data: any) => {
          if (data) {
            this.toaster.success('Segment Deleted Successfully !', '', {
              timeOut: 10000,
              positionClass: 'toast-top-center'
            });
            this.SegmentDeleted.emit('delete');
          }
        }, (error) => {
          if(error) {
            this.toaster.error(error?.error?.message, '', { 
              timeOut: 5000, 
              positionClass: 'toast-top-center' 
            });
          }
        });
      }
    });
  }

  segmentEditSubmit(event) {
    if(event) {
      this.hidepopup('editSegment');
      this.SegmentEditedByIdSubmit.emit('edited');
    }
  }

  frameProperCase(name: any): string {
    try {
    const str = (name ?? '').toString().trim();
    if (!str) return '';
    return str
      .split(/\s+/)
      .map(token => {
        const head = token.charAt(0);
        const tail = token.slice(1);
        return head.toUpperCase() + tail.toLowerCase();
      })
      .join(' ');
    } catch (error) {
      console.error('Error in frameProperCase:', error);
      return name.toString();
    }
  }

}





